import PublicRoutes from './public'
import UserRoutes from './user'
import AdminRoutes from './admin'
export { PublicRoutes, UserRoutes, AdminRoutes }
